<nav class="quiz-nav">
  <div class="quiz-nav-left">
    <a class="brand" routerLink="/quiz" title="Cinephile Trivia">
      <span class="brand-badge">
        <svg class="brand-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <polygon points="10 8 16 12 10 16 10 8"/>
        </svg>
      </span>
      <span class="brand-text">CINEPHILE</span>
    </a>
    <div class="quiz-nav-links">
      <a
        *ngFor="let link of navLinks"
        [routerLink]="link.path"
        [queryParams]="navQueryParams(link.path)"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: link.path === '/quiz' }"
        class="nav-btn">
        <span class="nav-label">{{ link.label }}</span>
      </a>
    </div>
  </div>

  <div class="quiz-nav-right">
    <div class="director-chip" *ngIf="directorName" title="Active Director Alias">
      <span class="director-indicator"></span>
      <span class="director-prefix">Director</span>
      <span class="director-name">{{ directorName }}</span>
    </div>

    <a class="back-home" routerLink="/" title="Return to Cinema Home">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
      <span>Back to Site</span>
    </a>

    <div class="ticket-badge" [class.flash]="ticketFlashing" title="Cinephile Tickets">
      <svg class="ticket-icon" [class.bounce]="ticketFlashing" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/>
        <path d="M13 5v2"/>
        <path d="M13 17v2"/>
        <path d="M13 11v2"/>
      </svg>
      <span class="ticket-count">{{ tickets | number }}</span>
    </div>
  </div>
</nav>
